import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ClearIcon from "@mui/icons-material/Clear";
import Slide from "@mui/material/Slide";
import { toast, ToastContainer } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { BsPlusLg } from "react-icons/bs";

import {
  getAircraft,
  getFlightData,
  updateFlight,
} from "../../../components/Axios/Axios";
import AddAircraftModal from "../../../components/Modal/AddAircraftModal";
import useCustomToast from "../../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";

const style = {
  position: "fixed",
  top: "0",
  right: "0",
  width: "60%",
  height: "900px",
  maxWidth: "500px",
  maxHeight: "100%",
  bgcolor: "white",
  boxShadow: 24,
  paddingLeft: "5%",
  paddingRight: "3%",
  overflow: "auto",
  zIndex: 9999,

  "&::-webkit-scrollbar": {
    //Beautifying scrollbar
    width: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
};

interface EditFlightprops {
  open: boolean;
  onCloseEdit: () => void;
  onOpenEdit: (flightData: any) => void;
  selectedFlightData: any;
  // landingsprop: number;
}

const EditFlight: React.FC<EditFlightprops> = ({
  open,
  onCloseEdit,
  onOpenEdit,
  selectedFlightData,
  // landingsprop,
}) => {
  console.log(open, "open auto", selectedFlightData);
  const [crewPositions, setCrewPositions] = useState<
    { label: string; value: string }[]
  >([]);

  const customToast = useCustomToast();
  const [userInput, setUserInput] = useState<UserInput>({}); // Use the UserInput type

  const [formsubmit, setFormSubmit] = React.useState(false);
  const [selectedAircraft, setSelectedAircraft] = useState<string>(selectedFlightData?.aircraft?.model
  );
  const [aircraftData, setAircraftData] = useState<any>([]);
  const [aircraftModels, setAircraftModels] = useState<any>([]);
  const [flightNumber, setFlightNumber] = useState(
    selectedFlightData?.flightNumber
  );
  const [flightId, setFlightId] = useState(selectedFlightData?.flightid);
  const [date, setDate] = useState(selectedFlightData?.flightDate);
  const [fromLoc, setFromLoc] = useState(
    selectedFlightData?.timesAndTelemetry?.flight?.starticaono
  );
  const [toLoc, setToLoc] = useState(
    selectedFlightData.timesAndTelemetry.flight?.endicaono
  );
  const [actualIn, setActualIn] = useState(selectedFlightData?.times?.actual_in);
  const [actualOut, setActualOut] = useState(
    selectedFlightData?.times?.actual_out
  );
  const [crewOptionsPresent, setCrewOptionsPresent] = useState<
    Array<Array<CrewOption>>
  >([]);
  const [totalTime, setTotalTime] = useState<number>(
    selectedFlightData?.times?.totalTime
  );
  const [day, setDay] = useState<number>(selectedFlightData?.times?.day);
  const [night, setNight] = useState<number>(selectedFlightData?.times?.night);
  const [landingDay, setLandingDay] = useState(
    selectedFlightData?.landingsAndApproaches?.fullStopDay
  );
  const [landingNight, setLandingNight] = useState(
    selectedFlightData?.landingsAndApproaches?.fullStopNight
  );
  const [takesOffDay, setTakesOffDay] = useState(
    selectedFlightData?.landingsAndApproaches?.takeoffDay
  );
  const [takesOffNight, setTakesOffNight] = useState(
    selectedFlightData?.landingsAndApproaches?.takeoffNight
  );
  const [approachesCheck, setApproachesCheck] = useState("");
  const [approachesInput, setApproachesInput] = useState(
    selectedFlightData?.landingsAndApproaches?.approaches
  );
  const [instrumentTimePercentageInput, setInstrumentTimePercentageInput] =
    useState("");
  const [actualOn, setActualOn] = useState(selectedFlightData?.times?.actual_on);
  const [actualOff, setActualOff] = useState(
    selectedFlightData?.times?.actual_off
  );
  const [instrumentTimePercentageCheck, setInstrumentTimePercentageCheck] =
    useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [route, setRoute] = useState("");
  const [fromCity, setFromcity] = useState("");
  const [toCity, setTocity] = useState("");
  const [
    autofilledValueInstrumentTimePercent,
    setAutofilledValueInstrumentTimePercent,
  ] = useState(selectedFlightData?.times?.imc);
  const [addAircraft, setAddAircraft] = React.useState(false);
  const [dualReceived, setDaulReceived] = React.useState("");
  const [pic, setPic] = React.useState(selectedFlightData?.times?.pic);
  const [sic, setSic] = React.useState(selectedFlightData?.times?.sic);
  const [ip, setIp] = React.useState(selectedFlightData?.times?.ip);
  const [ep, setEp] = React.useState(selectedFlightData?.times?.ep);
  const [lca, setLca] = React.useState(selectedFlightData?.times?.lca);
  const [studentPilot, setStudentPilot] = React.useState(
    selectedFlightData?.times?.studentPilot
  );
  const [solo, setSolo] = React.useState(selectedFlightData?.times?.solo);

  const handleAddAircraft = () => {
    setAddAircraft(true);
    onCloseEdit();
  };

  const handleCloseAircraft = () => {
    setAddAircraft(false);
  };

  const handleInstrumentTimePercentageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setInstrumentTimePercentageInput(event.target.value);
  };

  const calculateAutofilledValueInstrumentTimePercent = () => {
    const percentage = parseFloat(instrumentTimePercentageInput);
    if (!isNaN(percentage)) {
      const calculatedValue = (percentage / 100) * totalTime;
      setAutofilledValueInstrumentTimePercent(calculatedValue.toFixed(2));
    }
  };



  const resetAllStates = () => {
    setCrewPositions([]);
    setUserInput({});
    setSelectedAircraft("");
    setFormSubmit(false);
    setAircraftData([]);
    setAircraftModels([]);
    setFlightId("");
    setFlightNumber("");
    setFromLoc("");
    setToLoc("");
    setActualIn("");
    setActualOut("");
    setActualOn("");
    setActualOff("");
    setDate("");
    setTotalTime(0);
    setDay(0);
    setNight(0);
    setRoute("");
    setFromcity("");
    setTocity("");
    setInstrumentTimePercentageCheck("");
    setApproachesCheck("");
    setInstrumentTimePercentageInput("");
    setApproachesInput("");
    setCrewOptionsPresent([]);
    setIsModalOpen(false);
    setLandingDay("");
    setLandingNight("");
    setTakesOffDay("");
    setTakesOffNight("");
  };
  const handleDayBlur = () => {
    const dayValue = typeof day === "number" ? day : parseFloat(day); // Convert to float
    const remainingTime = Number(totalTime) - dayValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedNight = parseFloat(remainingTime.toFixed(2));
      setNight(roundedNight);
    }
  };

  const handleNightBlur = () => {
    const nightValue = typeof night === "number" ? night : parseFloat(night); // Convert to float
    const remainingTime = Number(totalTime) - nightValue;
    if (!isNaN(remainingTime) && remainingTime >= 0) {
      const roundedDay = parseFloat(remainingTime.toFixed(2));
      setDay(roundedDay);
    }
  };

  interface CrewOption {
    label: string;
  }
  type UserInput = {
    [key: string]: string;
  };

  const updateCrewPosition = (inputName: string, inputValue: string) => {
    const updatedCrewPositions = crewPositions.map((position) =>
      position.label === inputName
        ? { ...position, value: inputValue }
        : position
    );
    setCrewPositions(updatedCrewPositions);
  };

  const handleAircraftChange = async (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedAircraft(e.target.value);
    console.log(e.target.value);

    try {
      const selectedIndex =
        e.target.options[e.target.selectedIndex].getAttribute("data-index");
      if (selectedIndex !== null) {
    
        const index = parseInt(selectedIndex, 10);

        const data = aircraftData[index];
        const data2 = await getFlightData(data.identIcao);
        console.log("Flight data:", data2);

        console.log(data2.data.totalTimeMinutes);
        console.log(data.identIcao);
        console.log(data2);
      }
    } catch (error) {
      console.error(error);
    }
  };

  
  const handleEditFlight = async () => {

    try {
      const flightData = {
        flightid: flightId,
        flightNumber: flightNumber,
        flightDate: date,
        route:fromLoc+" to "+toLoc ,
        // aircraft: {
        //   // registration: registrationNo,
        //   // model: selectedAircraft,
        // },
        landingsAndApproaches: {
          approaches: parseInt(approachesInput),
          hold: false,
          totalLandings: parseInt(landingDay),
          fullStopDay: parseInt(landingDay),
          fullStopNight: parseInt(landingNight),
          takeoffs: parseInt(takesOffDay + takesOffNight),
          takeoffDay: parseInt(takesOffDay),
          takeoffNight: parseInt(takesOffNight),
          flightInstructor: false,
        },
        times: {
          dualReceived: dualReceived,
          sic: sic,
          pic: pic,
          ip: ip,
          ep: ep,
          lca: lca,
          solo: solo,
          studentPilot: studentPilot,
          asInstr: 0,
          crossCountry: 0,
          night: night,
          day: day,
          simInstrument: 0,
          imc: autofilledValueInstrumentTimePercent,
          groundSim: 0,
          totalTime: totalTime,
          totalTimeHours: totalTime,
          actual_out: new Date(actualOut),
          actual_on: new Date(actualOn),
          actual_off: new Date(actualOff),
          actual_in: new Date(actualIn),
        },
        timesAndTelemetry: {
          flight: {
            start: fromCity,
            end: toCity,
            starticaono: fromLoc,
            endicaono: toLoc,
          },
        },
      };
      //
      // Make an HTTP POST request to the backend API endpoint
      const response = await updateFlight(selectedFlightData._id, flightData);

        customToast("Flight updated successfully", "success");
        resetAllStates();
        onCloseEdit();
 
    } catch (error) {
      customToast("Failed to update Flight", "error");
    }
  };

  
  return (
    <>
    <Toaster/>
      <Modal open={open} onClose={onCloseEdit}>
        <Slide direction="left" in={open} mountOnEnter unmountOnExit>
          <Box sx={style}>
            <form action="">
              <div>
                <div className="clear_icon">
                  <ClearIcon
                    style={{ marginTop: "2%" }}
                    onClick={onCloseEdit}
                  />
                </div>
                <h2 className="heading2">Edit Flight</h2>

                <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                  Flight Details
                </p>
                <div
                  className="f-flex"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <label className="heading5" style={{ marginBottom: "5px" }}>
                    Aircraft
                  </label>
                  <button
                    onClick={handleAddAircraft}
                    type="button"
                    className="add_flight_btn"
                    style={{ marginBottom: "15px", marginLeft: "20%" }}
                  >
                    <BsPlusLg /> Add Aircraft
                  </button>
                  <AddAircraftModal
                    open={addAircraft}
                    onClose={handleCloseAircraft}
                  />
                </div>
                <div
                  className="add_group"
                  style={{ width: "100%", position: "relative" }}
                >
                  <input
                    type="text"
                    className="add_input"
                    placeholder="Select Aircraft"
                    value={selectedAircraft}
                    // onChange={(e) => setSelectedAircraft(e.target.value)}
                  />
                  {/* <select
                    className="add_input"
                    value={selectedAircraft}
                    onChange={handleAircraftChange}
                  >
                    <option value="" disabled selected>
                      Select your Aircraft
                    </option>
                    {aircraftModels.map((model: any, index: any) => (
                      <option key={index} value={model} data-index={index}>
                        {model}
                      </option>
                    ))}
                  </select> */}
                </div>

                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Flight Number
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                      marginRight: "10%",
                    }}
                  >
                    Date
                  </label>
                </div>

                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="UTF3235"
                      className="add_input"
                      value={flightNumber}
                      onChange={(e) => setFlightNumber(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="date"
                      placeholder="Select"
                      className="add_input"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    From
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    To
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="UK"
                      className="add_input"
                      value={fromLoc}
                      onChange={(e) => setFromLoc(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="USA"
                      value={toLoc}
                      className="add_input"
                      onChange={(e) => setToLoc(e.target.value)}
                    />
                  </div>
                </div>
                <div className="f-flex">
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Out (UTC)
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    In (UTC)
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+9:00"
                      className="add_input"
                      value={actualOut}
                      onChange={(e) => setActualOut(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+12:00"
                      className="add_input"
                      value={actualIn}
                      onChange={(e) => setActualIn(e.target.value)}
                    />
                  </div>
                </div>

                <p className="heading4 secondary" style={{ fontWeight: "600" }}>
                  TIME
                </p>
                <div style={{ display: "flex", flexGrow: "1" }}>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Total Time
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Day
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                      marginLeft: "7%",
                    }}
                  >
                    Night
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hourss"
                      className="add_input"
                      value={totalTime}
                      onChange={(e) => setTotalTime(Number(e.target.value))}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hours"
                      className="add_input"
                      value={day}
                      onChange={(e) => setDay(Number(e.target.value))}
                      onBlur={handleDayBlur}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="hours"
                      className="add_input"
                      value={night}
                      onChange={(e) => setNight(Number(e.target.value))}
                      onBlur={handleNightBlur}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    marginBottom: "1rem",
                    gap: "5%",
                  }}
                >
                  {pic !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                      // Add a unique key for each element
                    >
                      PIC
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="PIC"
                        value={pic}
                        onChange={(e) => setPic(e.target.value)}
                      />
                    </div>
                  )}
                  {sic !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                    >
                      SIC
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="SIC"
                        value={sic}
                        onChange={(e) => setSic(e.target.value)}
                      />
                    </div>
                  )}
                  {ep !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                      // Add a unique key for each element
                    >
                      EP
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        value={ep}
                        placeholder="EP"
                        onChange={(e) => setEp(e.target.value)}
                      />
                    </div>
                  )}
                  {ip !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                    >
                      IP
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="IP"
                        value={ip}
                        onChange={(e) => setIp(e.target.value)}
                      />
                    </div>
                  )}
                  {lca !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                    >
                      LCA
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="LCA"
                        value={lca}
                        onChange={(e) => setLca(e.target.value)}
                      />
                    </div>
                  )}
                  {solo !==0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                    >
                      Solo
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="Solo"
                        value={solo}
                        onChange={(e) => setSolo(e.target.value)}
                      />
                    </div>
                  )}
                  {studentPilot !== 0 && (
                    <div
                      style={{
                        fontWeight: "400",
                      }}
                      className="heading5"
                    >
                      Student Pilot
                      <input
                        className="add_group"
                        style={{
                          display: "flex",
                          width: "80%",
                          WebkitAppearance: "none",
                        }}
                        type="text"
                        placeholder="Student Pilot"
                        value={studentPilot}
                        onChange={(e) => setStudentPilot(e.target.value)}
                      />
                    </div>
                  )}
                </div>
                <div style={{ display: "flex" }}>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Takeoffs
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Landings
                  </label>
                </div>
                <div className="f-flex" style={{ gap: "8px" }}>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="Day"
                      className="add_input"
                      value={takesOffDay}
                      onChange={(e) => setTakesOffDay(e.target.value)}
                    />
                  </div>

                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="Night"
                      className="add_input"
                      value={takesOffNight}
                      onChange={(e) => setTakesOffNight(e.target.value)}
                    />
                  </div>

                  <div className="f-flex" style={{ gap: "8px" }}>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="Day"
                        className="add_input"
                        value={landingDay}
                        onChange={(e) => setLandingDay(e.target.value)}
                      />
                    </div>
                    <div
                      className="add_group"
                      style={{ display: "flex", flexGrow: "1" }}
                    >
                      <input
                        type="text"
                        placeholder="Night"
                        className="add_input"
                        value={landingNight}
                        onChange={(e) => setLandingNight(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "30%",
                  }}
                >
                  {/* Approaches */}
                  {approachesCheck === "" ? (
                    <div>
                      <p className="heading5">Approaches</p>
                      <input
                        className="add_group"
                        style={{ width: "170%" }}
                        type="text"
                        placeholder="Enter"
                        value={approachesInput}
                        onChange={(e) => setApproachesInput(e.target.value)}
                      />
                    </div>
                  ) : null}
                  {/* Approaches end */}

                  {/* Instrument Time Percentage */}
                  {instrumentTimePercentageCheck === "" ? (
                    <div style={{ marginRight: "5%" }}>
                      <p className="heading5">Instrument Time %</p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <input
                          style={{ width: "63%" }}
                          className="add_group"
                          type="text"
                          placeholder="%"
                          value={instrumentTimePercentageInput}
                          onChange={handleInstrumentTimePercentageChange}
                          onBlur={calculateAutofilledValueInstrumentTimePercent}
                        />
                        <input
                          style={{ width: "80%" }}
                          className="add_group"
                          type="text"
                          placeholder="value"
                          value={autofilledValueInstrumentTimePercent}
                          disabled
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
                <div
                  className="f-flex"
                  style={{ display: "flex", flexGrow: "1" }}
                >
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    Out (UTC)
                  </label>
                  <label
                    className="heading5"
                    style={{
                      marginBottom: "5px",
                      display: "flex",
                      flexGrow: "1",
                    }}
                  >
                    In (UTC)
                  </label>
                </div>
                <div className="f-flex">
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+9:00"
                      className="add_input"
                      value={actualOff}
                      onChange={(e) => setActualOff(e.target.value)}
                    />
                  </div>
                  <div
                    className="add_group"
                    style={{ display: "flex", flexGrow: "1" }}
                  >
                    <input
                      type="text"
                      placeholder="+12:00"
                      className="add_input"
                      value={actualOn}
                      onChange={(e) => setActualOn(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="button"
                    className="add_btn"
                    style={{ float: "right" }}
                    onClick={handleEditFlight}
                  >
                    <span>Update Flight</span>
                  </button>

                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </div>
            </form>
          </Box>
        </Slide>
      </Modal>
    </>
  );
};

export default EditFlight;
